import React from "react";
import { Stack } from "@mui/material";
import { GQLIamRole, useGetUserRolesQuery } from "@quales/data-access/graphql";
import { useTranslations } from "next-intl";
import { CustomTextField, CustomAutoComplete } from "../ui/input";

interface RoleListProps {
  onValueChanged: any;
  edit?: boolean;
  InputPropsValue?: any;
  width?: number | string;
  error: boolean;
}

export const RoleList = function (props: RoleListProps) {
  const { onValueChanged, edit, InputPropsValue, width, error } = props;
  const t = useTranslations("");
  const { loading, data } = useGetUserRolesQuery();

  const [value, setValue] = React.useState(InputPropsValue || []);
  const [options, setOptions] = React.useState<any>([]);

  React.useEffect(() => {
    if (data && data?.Roles && data.Roles.length > 0) {
      const newRoles = data.Roles.map((role: GQLIamRole) => ({
        //@ts-ignore
        name: role.roleName,
        id: role.roleID,
      }));
      setOptions([...newRoles]);
      onValueChanged(newRoles);
    }
  }, [data, data?.Roles]);

  const onChange = function (inputVal: any) {
    onValueChanged(inputVal);
    setValue(inputVal);
  };

  return (
    <Stack id="RoleList">
      {options && options.length > 0 && (
        <CustomAutoComplete
          id="tags-roles"
          sx={{ width: width ? width : 600 }}
          value={value}
          disabled={!edit}
          filterSelectedOptions
          onChange={(event, newValue) => {
            if (edit) {
              onChange(newValue);
            }
          }}
          multiple
          //@ts-ignore
          getOptionLabel={(option) => option.name}
          // @ts-ignore
          renderOption={(propsVal: any, option: any) => (
            <li {...propsVal} key={option.id}>
              {option.name}
            </li>
          )}
          options={options}
          loading={loading}
          defaultValue={[]}
          renderInput={(params) => (
            <CustomTextField
              controldisabled={!edit}
              error={error}
              required
              {...params}
              label={t("labels.role")}
              placeholder={t("labels.role")}
            />
          )}
        />
      )}
    </Stack>
  );
};

export default RoleList;
